/**
 * Shared revision check for the single-slot entity slices (BSE, contract, bid).
 *
 * The id guards already drop a response that targets a different entity than the
 * one in the slot. This additionally drops an out-of-order response for the SAME
 * entity: if two saves (or a slow reload) for one entity resolve in the wrong
 * order, the older revision must not overwrite the newer one already in the slot.
 *
 * `lastChanged` is an ISO timestamp, but its source differs — edits stamp the
 * client clock (`new Date().toISOString()`) while loads carry the server
 * `modifiedAt`. Comparing across sources is exposed to clock skew, so we drop
 * only on a STRICTLY older timestamp. Ties and unparseable values compare false
 * and therefore apply — which also preserves the edit-thunk failure path that
 * returns the unchanged `lastChanged` alongside an inline error message.
 */
export const isOlderRevision = (
  incoming: { lastChanged: string },
  current: { lastChanged: string }
): boolean => new Date(incoming.lastChanged) < new Date(current.lastChanged);
